export type AiChatMessageRole = 'user' | 'ai' | 'system'

export type AiChatPendingState = 'thinking' | { tool: string } | 'streaming' | null

export interface AiChatMessage {
	id: string
	role: AiChatMessageRole
	text?: string
	html?: string
	streaming?: boolean
	pending?: AiChatPendingState
	question?: string
	threadId?: string
	contextId?: string
}

let nextId = 0
export function createMessageId(): string {
	nextId += 1
	return `ai-chat-msg-${Date.now()}-${nextId}`
}
